import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/cross_white.svg'
import _imports_1 from '@/assets/img/cross.svg'


const _withScopeId = n => (_pushScopeId("data-v-000c520f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "opModal formContainer" }
const _hoisted_2 = {
  key: 0,
  class: "errorMessage"
}
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "body" }
const _hoisted_8 = {
  key: 0,
  class: "row mt-4"
}
const _hoisted_9 = {
  key: 1,
  class: "row mt-4"
}
const _hoisted_10 = { class: "col-12" }
const _hoisted_11 = { class: "materials" }
const _hoisted_12 = {
  key: 0,
  class: "row"
}
const _hoisted_13 = { class: "col-sm-6" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = { class: "d-flex align-items-center" }
const _hoisted_16 = { class: "d-flex align-items-center me-3" }
const _hoisted_17 = { class: "d-flex align-items-center me-3" }
const _hoisted_18 = { class: "col-sm-6" }
const _hoisted_19 = {
  key: 1,
  class: "row"
}
const _hoisted_20 = { class: "col-sm-6" }
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = { class: "col-sm-6" }
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = {
  key: 1,
  class: "d-block mt-3 mb-4"
}
const _hoisted_25 = {
  key: 2,
  class: "row"
}
const _hoisted_26 = { class: "col-sm-12" }
const _hoisted_27 = {
  key: 1,
  class: "form-group"
}
const _hoisted_28 = {
  key: 0,
  class: "d-block mt-3 mb-4"
}
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col-sm-3" }
const _hoisted_31 = { class: "col-sm-4" }
const _hoisted_32 = { class: "col-sm-4" }
const _hoisted_33 = { class: "col-sm-1 d-flex align-items-center justify-content-end" }
const _hoisted_34 = ["disabled"]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_36 = { class: "table table-striped" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { colspan: "99" }
const _hoisted_40 = { class: "d-flex justify-content-end" }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = { class: "text-center mt-3" }
const _hoisted_43 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_form_field = _resolveComponent("form-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.errorMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createTextVNode(_toDisplayString(_ctx.errorMessage) + " ", 1),
          _createElementVNode("img", {
            src: _imports_0,
            class: "pointer",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.errorMessage = ''))
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (!_ctx.editModel.index && _ctx.editModel.index != 0)
          ? (_openBlock(), _createBlock(_component_localized_text, {
              key: 0,
              localizedKey: "Add Fabric",
              text: "Add Fabric"
            }))
          : (_openBlock(), _createBlock(_component_localized_text, {
              key: 1,
              localizedKey: "Edit Fabric",
              text: "Edit Fabric"
            }))
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-modal-close",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
      }, _hoisted_6)
    ]),
    _createElementVNode("div", _hoisted_7, [
      (!_ctx.isPaddingLayer)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", {
              class: _normalizeClass(!_ctx.firstLayerAdded || _ctx.firstLayerAdded && _ctx.firstLayerGrams ? 'col-6' : 'col-6')
            }, [
              _createVNode(_component_form_field, {
                type: "text",
                labelKey: "Fabric Name",
                labelValue: "Fabric Name",
                placeholderKey: "Fabric Name",
                placeholderValue: "Fabric Name",
                modelValue: _ctx.localModel.layerName,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localModel.layerName) = $event))
              }, null, 8, ["modelValue"])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(!_ctx.firstLayerAdded || _ctx.firstLayerAdded && _ctx.firstLayerGrams ? 'col-6' : 'col-6')
            }, [
              _createVNode(_component_form_field, {
                type: "number",
                labelKey: _ctx.isFirstLayer ? 'Total SQM consumption (suggested {{suggestedSQM}})' : 'Total SQM consumption',
                labelValue: _ctx.isFirstLayer ? 'Total SQM consumption (suggested {{suggestedSQM}})' : 'Total SQM consumption',
                labelObject: { suggestedSQM: _ctx.suggestedSQM },
                placeholderKey: "Total SQM consumption",
                placeholderValue: "Total SQM consumption",
                modelValue: _ctx.localModel.sqm,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localModel.sqm) = $event)),
                min: "0"
              }, null, 8, ["labelKey", "labelValue", "labelObject", "modelValue"])
            ], 2)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_form_field, {
                type: "text",
                labelKey: "Fabric Name",
                labelValue: "Fabric Name",
                placeholderKey: "Fabric Name",
                placeholderValue: "Fabric Name",
                modelValue: _ctx.localModel.layerName,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.localModel.layerName) = $event))
              }, null, 8, ["modelValue"])
            ])
          ])),
      _createElementVNode("div", _hoisted_11, [
        (!_ctx.firstLayerAdded && !_ctx.isPaddingLayer)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_localized_text, {
                    type: "label",
                    localizedKey: "Do you have a specific fabric weight?",
                    text: "Do you have a specific fabric weight?"
                  }),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["sameAsCheckbox pointer me-2", { active: _ctx.specificWeight }]),
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.specificWeight = true))
                      }, null, 2),
                      _createVNode(_component_localized_text, {
                        localizedKey: "Yes",
                        text: "Yes"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["sameAsCheckbox pointer me-2", { active: !_ctx.specificWeight }]),
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.clearSpecificWeight()))
                      }, null, 2),
                      _createVNode(_component_localized_text, {
                        localizedKey: "No",
                        text: "No"
                      })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                (_ctx.specificWeight)
                  ? (_openBlock(), _createBlock(_component_form_field, {
                      key: 0,
                      type: "number",
                      labelKey: "Total Grams",
                      labelValue: "Total Grams",
                      placeholderKey: "Total Grams",
                      placeholderValue: "Total Grams",
                      modelValue: _ctx.localModel.grams,
                      "onUpdate:modelValue": _ctx.gramsUpdated
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : (_ctx.firstLayerAdded && _ctx.firstLayerGrams && !_ctx.isPaddingLayer)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_localized_text, {
                      type: "label",
                      localizedKey: "Do you have a specific fabric weight?",
                      text: "Do you have a specific fabric weight?"
                    }),
                    (_ctx.specificWeight)
                      ? (_openBlock(), _createBlock(_component_localized_text, {
                          key: 0,
                          class: "d-block mt-3 mb-4",
                          localizedKey: "Yes",
                          text: "Yes"
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    (_ctx.specificWeight)
                      ? (_openBlock(), _createBlock(_component_localized_text, {
                          key: 0,
                          type: "label",
                          localizedKey: "Total Grams",
                          text: "Total Grams"
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.specificWeight)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.firstLayerGrams), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : (_ctx.isPaddingLayer)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    (_ctx.specificWeight && !_ctx.firstLayerGrams)
                      ? (_openBlock(), _createBlock(_component_form_field, {
                          key: 0,
                          type: "number",
                          labelKey: "Indicate total grams of padding",
                          labelValue: "Indicate total grams of padding",
                          placeholderKey: "Indicate total grams of padding",
                          placeholderValue: "Indicate total grams of padding",
                          modelValue: _ctx.localModel.grams,
                          "onUpdate:modelValue": _ctx.gramsUpdated
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                      : (_ctx.specificWeight && _ctx.firstLayerGrams)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                            _createVNode(_component_localized_text, {
                              type: "label",
                              localizedKey: "Indicate total grams of padding",
                              text: "Indicate total grams of padding"
                            }),
                            (_ctx.specificWeight)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.firstLayerGrams), 1))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _createVNode(_component_form_field, {
              type: "select",
              labelKey: "Material",
              labelValue: "Material",
              placeholderKey: "Material",
              placeholderValue: "Material",
              list: _ctx.filteredRawMaterials,
              modelValue: _ctx.tempFabricIdentifier,
              "onUpdate:modelValue": [
                _cache[7] || (_cache[7] = ($event: any) => ((_ctx.tempFabricIdentifier) = $event)),
                _ctx.checkIfIsLeatherMaterial
              ]
            }, null, 8, ["list", "modelValue", "onUpdate:modelValue"])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createVNode(_component_form_field, {
              type: "number",
              labelKey: "Percentage (Remaining{{remainingPercentage}})",
              labelValue: "Percentage (Remaining {{remainingPercentage}}%)",
              labelObject: { remainingPercentage: _ctx.remainingPercentage},
              disabled: _ctx.disablePercentage,
              placeholderKey: "Percentage",
              placeholderValue: "Percentage",
              modelValue: _ctx.tempFabricPercentage,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.tempFabricPercentage) = $event))
            }, null, 8, ["labelObject", "disabled", "modelValue"])
          ]),
          _createElementVNode("div", _hoisted_32, [
            (_ctx.isPaddingLayer)
              ? (_openBlock(), _createBlock(_component_form_field, {
                  key: 0,
                  type: "number",
                  labelKey: "Grams",
                  labelValue: "Grams",
                  readonly: _ctx.gramsCustomized,
                  placeholderKey: "Grams",
                  placeholderValue: "Grams",
                  modelValue: _ctx.tempGrams,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.tempGrams) = $event))
                }, null, 8, ["readonly", "modelValue"]))
              : (_openBlock(), _createBlock(_component_form_field, {
                  key: 1,
                  type: "number",
                  labelKey: "Grams (suggested {{suggestedGrams}})",
                  labelValue: "Grams (suggested {{suggestedGrams}})",
                  labelObject: { suggestedGrams: _ctx.tempSuggestedGrams },
                  readonly: _ctx.gramsCustomized,
                  placeholderKey: "Grams",
                  placeholderValue: "Grams",
                  modelValue: _ctx.tempGrams,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.tempGrams) = $event))
                }, null, 8, ["labelObject", "readonly", "modelValue"]))
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-tertiary",
              disabled: _ctx.adddisabled,
              onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.addLayer && _ctx.addLayer(...args)))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Add",
                text: "Add"
              })
            ], 8, _hoisted_34)
          ])
        ]),
        _hoisted_35,
        _createElementVNode("table", _hoisted_36, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Material",
                  text: "Material"
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Percentage",
                  text: "Percentage"
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Grams",
                  text: "Grams"
                })
              ]),
              _hoisted_37
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_ctx.localModel.fabrics.length == 0)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_38, [
                  _createElementVNode("td", _hoisted_39, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "No Elements Found",
                      text: "No Elements Found"
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localModel.fabrics, (item, i) => {
              return (_openBlock(), _createElementBlock("tr", { key: i }, [
                _createElementVNode("td", null, _toDisplayString(item.rawMaterial.text), 1),
                _createElementVNode("td", null, _toDisplayString(item.percentage) + "%", 1),
                _createElementVNode("td", null, _toDisplayString(item.gramsPerSQM), 1),
                _createElementVNode("td", _hoisted_40, [
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    onClick: ($event: any) => (_ctx.removeFabric(i))
                  }, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Remove",
                      text: "Remove"
                    })
                  ], 8, _hoisted_41)
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_42, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-tertiary",
          disabled: _ctx.disabled,
          onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
        }, [
          (_ctx.editModel.layerName)
            ? (_openBlock(), _createBlock(_component_localized_text, {
                key: 0,
                localizedKey: "Edit",
                text: "Edit"
              }))
            : (_openBlock(), _createBlock(_component_localized_text, {
                key: 1,
                localizedKey: "Create",
                text: "Create"
              }))
        ], 8, _hoisted_43)
      ])
    ])
  ]))
}